/**
 * Shared session invalidation state.
 *
 * Both the Axios interceptor and the WebSocket handler need to coordinate
 * so that only ONE of them runs cleanup + overlay when a session is killed.
 * This module is the single source of truth for that flag.
 */

let _isSessionInvalidatedHandled = false;
let _isLoggingOut = false;

/**
 * Returns true if session invalidation cleanup is already in progress
 * (either from the Axios interceptor or the WebSocket handler).
 */
export const isSessionInvalidationInProgress = (): boolean =>
  _isSessionInvalidatedHandled;

/**
 * Claim the session invalidation lock.
 * Returns true if this caller won the lock, false if someone else already has it.
 */
export const claimSessionInvalidation = (): boolean => {
  if (_isSessionInvalidatedHandled) return false;
  _isSessionInvalidatedHandled = true;
  return true;
};

/**
 * Release the lock (e.g. after the user dismisses the overlay and navigates to /login).
 */
export const resetSessionInvalidation = (): void => {
  _isSessionInvalidatedHandled = false;
};

/**
 * Flag that an intentional logout is in progress.
 * The interceptor should suppress session-invalidation handling during this time.
 */
export const setLoggingOut = (value: boolean): void => {
  _isLoggingOut = value;
};

export const isLoggingOut = (): boolean => _isLoggingOut;
